import { Button } from "@/components/ui/button";
import { appConfig } from "@/constants";

export const KeyAnimation = ({
  handleAnimationClick,
}: { handleAnimationClick: () => void }) => {
  const spline = {
    url: `${appConfig.SPLINE_VIEWER}/T5erQ-DfxB5M7VSg?1d5c8b83-2300-4c3c-8e58-56b830fd6c1c=1`,
    size: "150%",
  };

  return (
    <Button
      className="relative w-full aspect-square bg-transparent"
      onClick={handleAnimationClick}
    >
      <iframe
        src={spline?.url}
        title="IMX Keys Animation"
        className="absolute w-[150%] h-[150%] -top-[25%] -left-[25%]"
        style={{
          pointerEvents: "none",
          border: "none",
          colorScheme: "auto",
        }}
        loading="eager"
      />
    </Button>
  );
};
